import { render, staticRenderFns } from "./icon-upload.vue?vue&type=template&id=9e6fc0d0"
import script from "./icon-upload.vue?vue&type=script&lang=ts"
export * from "./icon-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports